import { TextField } from '@mui/material';
import React, { ComponentProps, FC, forwardRef } from 'react';
import { InputAttributes, NumericFormat } from 'react-number-format';
import { ControlledInput } from '../controlled-input/controlled-input.component';

type Props = ComponentProps<typeof TextField> & {
    name: string;
    decimalScale?: number;
};

interface NumberFormatProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    decimalScale?: number;
}

export const NumberInput = forwardRef<typeof NumericFormat<InputAttributes>, NumberFormatProps>(
    ({ onChange, name, decimalScale = 2, ...other }, ref) => {
        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: name,
                            value: values.value,
                        },
                    });
                }}
                thousandSeparator=" "
                decimalSeparator=","
                valueIsNumericString
                allowNegative={false}
                decimalScale={decimalScale}
            />
        );
    },
);

export const ControlledNumberInput: FC<Props> = ({ decimalScale, InputProps, ...textFieldProps }) => {
    return (
        <ControlledInput
            slotProps={{
                htmlInput: { decimalScale },
                input: { inputComponent: NumberInput as any, ...InputProps },
            }}
            {...textFieldProps}
        />
    );
};
